import React, {Component} from 'react'
import {Route, Redirect, withRouter, Switch} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import './index.css'

import {
  authenticateUser
} from '../../stores/auth'

import ViewAll from '../../containers/ViewAll'
import View from '../../containers/View'
import Uploads from '../../containers/Uploads'
import Profile from '../../containers/Profile'
import AuthRoute from '../../containers/AuthRoute'
import Login from '../../containers/Login'

class App extends Component {
  componentDidMount() {
    this.props.authenticateUser()
  }

  render() {
    const {authenticated} = this.props

    return (
      <div className='App'>
        <main>
          {
            authenticated ?
              <Switch>
                <AuthRoute exact path='/' component={ViewAll}/>
                <AuthRoute exact path='/view' component={ViewAll}/>
                <AuthRoute exact path='/view/:sfid' component={View}/>
                {/* The Uploads tab is hidden unless the account has upload access (Services Provided);
                    the container itself also refuses to load data for accounts without access. */}
                <AuthRoute exact path='/uploads' component={Uploads}/>
                <AuthRoute exact path='/profile' component={Profile}/>
                <Redirect to='/'/>
              </Switch> :
              <Route exact path="/login" component={Login}/>
          }
        </main>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({
      authenticateUser
    }, dispatch)
  }
}

const mapStateToProps = (state, route) => {
  const {authenticated} = state.stores.auth

  return ({
    ...route.match.params,
    authenticated
  })
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
